import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const StoreRedirect = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const playstoreUrl = params.get("android");
    const appstoreUrl = params.get("ios");

    const userAgent = navigator.userAgent.toLowerCase();
    const isApple =
      /iphone|ipad|ipod|macintosh|mac os x/.test(userAgent) ||
      (navigator.platform && /mac/i.test(navigator.platform));

    if (isApple && appstoreUrl) {
      window.location.href = appstoreUrl;
    } else if (playstoreUrl) {
      window.location.href = playstoreUrl;
    } else {
      console.error("No redirect URLs provided.");
    }
  }, [search]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <p>Redirecting to store...</p>
      </div>
    </div>
  );
};

export default StoreRedirect;
